import navigation from "@/content/navigation";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import Logo from "../Logo";
import Navicon from "../Navicon";
import SubNav from "../SubNav";
import styles from "./Header.module.css";
const Header: React.FC = () => {
  const router = useRouter();
  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <header
        className={`${styles.header} grid-container ${isActive ? styles.active : ""}`}
      >
        <div className="lg-col-span-6">
          <Logo />
        </div>

        <nav className="lg-col-span-6">
          <ul className={styles.navItems}>
            {navigation.map((item) => (
              <li key={item.name}>
                <Link
                  href={item.href}
                  onClick={() => {
                    setIsActive(false); // Close the menu on link click
                  }}
                  className={`${
                    router.pathname === item.href ||
                    router.pathname.startsWith(item.href + "/")
                      ? styles.active
                      : ""
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
            <li className={styles.contactUs}>
              <Link
                href="/contact"
                className={`${router.pathname === "/contact" ? styles.active : ""}`}
                onClick={() => {
                  setIsActive(false); // Close the menu on link click
                }}
              >
                <span>Contact Us</span>
                <span>&#x2192;</span>
              </Link>
            </li>
          </ul>
          <Navicon
            onClick={() => {
              setIsActive(!isActive); // Toggle the active state
            }}
            active={isActive}
          />
        </nav>
      </header>
      <SubNav />
    </>
  );
};

export default Header;
